import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sidebar1',
  templateUrl: './sidebar1.component.html',
  styleUrls: ['./sidebar1.component.scss']
})
export class Sidebar1Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
